<template>
  <div class="map-container" :class="{lg: large}">
    <div class="row lined">
        <div class="col">
            <auto-complete
                loose
                focus
                placeholder="Enter Address"
                :list="addressNames"
                :selection="getSelectedAddress"
                @input="findAddresses"
                @change="setAddress"
            ></auto-complete>
        </div>
    </div>
    <div class="row lined">
      <div class="col">
          <div class="btn btn-download" style="margin: 5px;"  v-for="m, i in availableMedia " :class="{disabled: selectedMedia.indexOf(m) < 0 }" @click="setCarrierMedia(m)">
              <div>{{ m }}</div>
              </button>

          </div>

      </div>
    </div>
    <div class="row ">
      <div class="selected-carriers">

        <div class="btn btn-download" style="margin: 5px;"  v-for="c, i in availableCarriers " :class="{disabled: selectedCarriers.indexOf(c) < 0 }" @click="toggleCarrier(c)">
             <div>{{ c }}</div>
          </button>

        </div>
      </div>
    </div>
      <div id="map" :class="[ large ?'lg': 'std']"></div>

        <pulse-loader style="text-align:center;" class="loader" slot="loading" :loading="searching" color="#5e9cd3"></pulse-loader>


  </div>

</template>

<script type="text/babel">
  import PulseLoader from 'vue-spinner/src/PulseLoader.vue';
  import AutoComplete from '../assets/Autocomplete.vue';
  import MultiSelect from '../assets/MultiSelect.vue';
  import Dropdown from '../assets/Dropdown.vue';
  export default {
    name: "MiniMap",
    data() {
      return {
        touched:false,
        location:{
          formatted_address: '',
          geolat: '',
          geolong: '',
          address: '',
          neighborhood: '',
          city: '',
          state: '',
          country: '',
          zip: ''
        },
        addresses:[],
        mapContainer: 'map',
        carrier:{

        },
        carrierMedia:[],
        selectedMedia: [],
        selectedCarriers: [],
        carrierLocations: [],
        map: {},
        timer: {},
        markersArray:[],
        searching: false,
        current: 0,

        availableMedia: [],
        availableCarriers: [],
        mapSetUp: false
      }
    },
    components:{
      AutoComplete,
      Dropdown,
      MultiSelect,
      PulseLoader
    },
    computed:{
        filteredLocations(){
            var _this = this;

            var filtered = [];

            this.carrierLocations.forEach(function(location){
                var locationCarriers = [];

                if(!location.carriers.length) return;

                location.carriers.forEach(function(carrier){
                    if(_this.selectedCarriers.indexOf(carrier.name) < 0 ) return;
                    var carrierObject = {};
                    if(!carrier.media.length) return;

                    carrier.media.forEach(function(media){

                        if(_this.selectedMedia.indexOf(media) < 0) return;

                        carrierObject = carrierObject || {};
                        carrierObject.carrier_id = carrier.carrier_id;
                        carrierObject.download =  carrier.download;
                        carrierObject.name =  carrier.name;
                        carrierObject.source =  carrier.source;
                        carrierObject.upload =  carrier.upload;
                        carrierObject.media = carrierObject.media || [];
                        carrierObject.media.push(media);
                    });

                    if(carrierObject.carrier_id){
                        locationCarriers.push(carrierObject)
                    }

                });

                if(locationCarriers.length){
                    filtered.push({
                        carriers: locationCarriers,
                        location: location.location,
                        pin_url: location.pin_url
                    })
                }
            });
            return filtered;
        },
        getSelectedAddress(){
            if(this.location){
              return this.location.formatted_address
            }
            return '';
        },
        addressNames(){
            return this.addresses.map(function(a){
              return a.formatted_address;
            })
        },
    },
    filters:{

    },
    created(){
        this.map = new window.TCMap();


        if(this.address.geolat && this.address.geolong){
            this.location = this.address;
        } else {
            this.location.geolat = 39.8283;
            this.location.geolong = -98.5795;
        }

    },
    mounted(){
      var _this = this;

      this.setUpMap();
    },
    methods:{
        setUpMap(){
            var _this = this;

            this.showMap(this.map, {
                lat: this.location.geolat,
                lng: this.location.geolong
            });

            if(this.mapSetUp) return;
            this.map.map.addListener('bounds_changed', function() {
                _this.searching = true;
                console.log('bounds Changed');
                clearTimeout(_this.timer);
                _this.timer = setTimeout(function() {
                    _this.showPins();
                }, 2000);
            });
            _this.mapSetUp = true;

        },
        findAddresses(address){
            this.location.formatted_address = address;
            this.searchGoogle(address);
        },
        searchGoogle: _.debounce(function(address) {
            var _this = this;
            this.map.search(address, function (err, data) {
              if (err) {
                console.error(err);
              } else {
                _this.addresses = data;
              }
            })
          }, 500),
        setAddress(address){
            var _this = this;

            if(!address) {
                this.location = {
                    formatted_address: '',
                    geolat: '',
                    geolong: '',
                    address: '',
                    neighborhood: '',
                    city: '',
                    state: '',
                    country: '',
                    zip: ''
                }
                return;
            }


            this.location = this.addresses.filter(function(a){
              return a.formatted_address == address;
            }).map(function(a){
               console.log(a.address_components);

              var data = {
                formatted_address: a.formatted_address,
                geolat: a.geometry.location.lat(),
                geolong: a.geometry.location.lng(),
                address: ''
              };

            if(a.address_components[0]) data.address = a.address_components[0].short_name;
            if(a.address_components[1]) data.address += a.address_components[1].short_name;


              if(a.address_components[2]) data.neighborhood =  a.address_components[2].short_name;
              if(a.address_components[3]) data.city =  a.address_components[2].short_name;
              if(a.address_components[5]) data.state =  a.address_components[5].short_name;
              if(a.address_components[6]) data.country =  a.address_components[6].short_name;
              if(a.address_components[7]) data.zip =  a.address_components[7].short_name;
              return data;
            })[0];

              this.setUpMap();
          },
        toggleCarrier(carrier){

            if(this.selectedCarriers.indexOf(carrier) < 0){
                this.selectedCarriers.push(carrier);
            } else {
                this.selectedCarriers.splice(this.selectedCarriers.indexOf(carrier), 1);
            }
            this.touched = true;
            this.updateMarkers();
        },
        setCarrierMedia(value){

            if(this.selectedMedia.indexOf(value) >=0){
                this.selectedMedia.splice(this.selectedMedia.indexOf(value), 1);
                this.touched = true;
            } else {
                this.selectedMedia.push(value);
            }
            this.updateMarkers();
            //this.showPins();
        },
        setCarrier(carrier){
            if(this.selectedCarriers.indexOf(carrier) < 0){
                this.selectedCarriers.push(carrier);
            }
            this.updateMarkers();
        },

        showMap(map, data){

            var width = $(window).width();
            var zoom = 20;
            if(width < 600){
                zoom = 16;
            } else if(width < 950){
                zoom = 18;
            }


            map.show({
              container: this.mapContainer,
              mapOptions:{
                center:{
                  lat: parseFloat(data.lat),
                  lng: parseFloat(data.lng)
                },
                zoom: zoom
              }
            }, () => {
              map.addMarker({
                position: {
                  lat: parseFloat(data.lat),
                  lng: parseFloat(data.lng)
                }
              }, marker => {

              })

            });
          },
        showPins(){
            var _this = this;
            this.searching = true;

            _this.current = Date.now();
            var bounds = _this.map.map.getBounds();
            var NECorner = bounds.getNorthEast();
            var SWCorner = bounds.getSouthWest();

            this.$send(this, 'carrierLocations',{
                max_lat: NECorner.lat(),
                min_lat: SWCorner.lat(),
                min_lng: SWCorner.lng(),
                max_lng: NECorner.lng(),
                media: [],
                time: _this.current
            }).then(r => {


                this.carrierLocations = r.carrierLocations || [];
                if (r.time == _this.current){

                    this.availableMedia = [];
                    this.availableCarriers = [];

                    var allCarriers = [];
                    var allMedia = [];

                    this.carrierLocations.forEach(function(location){
                        location.carriers.forEach(function(carrier){
                            allCarriers.push({
                                id: carrier.carrier_id,
                                name: carrier.name
                            });
                            carrier.media.forEach(function(media){
                                allMedia.push(media);
                            })
                        })
                    });

                    this.availableCarriers = [...new Set(allCarriers.map(c => c.name))];
                    this.availableMedia = allMedia.filter(function(c, i){ return allMedia.indexOf(c) == i; });


                    if(!this.touched){
                        this.selectedCarriers = JSON.parse(JSON.stringify(this.availableCarriers));
                        this.selectedMedia = JSON.parse(JSON.stringify(this.availableMedia));

                    }

                    this.updateMarkers();
                }
            })
          },
        removeMarkers(){
            var _this = this;
            for(var m in _this.markersArray){
              _this.markersArray[m].setMap(null);
            }
            _this.markersArray = [];
         },
        updateMarkers(){
            var _this = this;
            var carrierLocation = {};
            var marker = {};
            var message = '';
            this.removeMarkers();
            _this.searching = false;
            if(!this.carrierLocations) return null;

            for (var i = 0; i < this.filteredLocations.length; i++) {
                carrierLocation = this.filteredLocations[i];
                marker = new google.maps.Marker({
                    position: new google.maps.LatLng(carrierLocation.location.geolat, carrierLocation.location.geolong),
                    title: carrierLocation.location.formatted_address,
                    shadow: null,
                    id: carrierLocation.location.location_id,
                    icon: carrierLocation.pin_url,
                });

                marker.setMap(_this.map.map);

              _this.markersArray.push(marker);
              message = "Carriers at this location:<br /><br />";
              var carrier = {};
              for (var j = 0; j < carrierLocation.carriers.length; j++){
                carrier =  carrierLocation.carriers[j];
                message += carrier.name + ' ( ' + carrier.media.join(',') + ' ) <br />';
              }
              _this.attachSecretMessage(marker, message);
        }

      },
        attachSecretMessage(marker, message) {
            var _this = this;
            var infowindow = new google.maps.InfoWindow({
                content: message,
                size: new google.maps.Size(50,50),
                disableAutoPan: true
              });


              marker.addListener('mouseover', function() {
                infowindow.open(_this.map, marker);
              });
              marker.addListener('mouseout', function() {
                infowindow.close(_this.map, marker);
              });

          }
    },
    props:{
      address: {},
      carriers: {},
        large:{
            type: Boolean,
            default: false
        }
    }
  }
</script>

<style>
  #map.std{
    height: 500px;
  }
  #map.lg{
    position: absolute;
    bottom:10px ;
    left:10px;
    right: 10px;
    top: 158px;
  }

  .map-container.lg {
      background: white;
      position: absolute;
      left: 10px;
      right: 10px;
      bottom: 10px;
      top: 66px;
      padding: 0 20px;
  }


  #edit-map{
    background: #f5f5f5;
    position: absolute;
    top: 10px;
    left:10px;
    right:10px;
    bottom:10px;

  }

  .carrier-dropdown .dropdown-menu{
    font-size: 12px;

  }
  .carrier-dropdown{
    display: inline-block;
    margin: 5px;
  }


   .selected-carriers {
     padding: 0 10px;
   }
    .map-container{
        background:white;
        border: 1px solid #e2e2e2;
    }
  .loading-cover {
    position: absolute;
    z-index: 1000;
    bottom:0px ;
    left:0px;
    right: 0px;
    top: 48px;
    background: rgba(255, 255,255,0.86);
  }

   .loader{
       text-align: center;
       margin-top: -10px;
       top: 50%;
       left: 50%;
       position: absolute;
       margin-left: -50px;
   }
    .btn.btn-options,
    .btn.btn-options.disabled{
        cursor: pointer;
    }

</style>



// WEBPACK FOOTER //
// MiniMap.vue?60dbc9fc